import gql from 'graphql-tag';

export default gql`
  mutation updateFilesFolderFileMutation($folder: MongoID!, $files: [MongoID!]) {
    updateFilesFolderFileMutation(folder: $folder, files: $files) {
      message
      title
    }
  }
`;
